import AbstractRoute from './AbstractRoute';

export default class PublicRoute extends AbstractRoute {
    isAccessGranted(): boolean {
        return this.permissionsGranted();
    }

    protected userDetailsNowLoading(): boolean {
        return false;
    }
}
